(function () {
  // Selectors for product detail pages (PDP)
  const PRODUCT_GALLERY_SELECTOR = 'media-gallery';
  const PRODUCT_EXCLUDED_SELECTOR =
    'featured-product-information, .dialog-zoomed-gallery, .quick-add-modal';

  // Helper to determine active template
  function getTemplate() {
    const main = document.getElementById('MainContent');
    const template = main && main.getAttribute('data-template');
    return template ? template.split('.')[0] : '';
  }

  function isProductTemplate() {
    return getTemplate() === 'product' || window.location.pathname.includes('/products/');
  }

  function isArticleTemplate() {
    return getTemplate() === 'article';
  }

  // 1. Inject Styles
  const style = document.createElement('style');
  style.textContent = `
    .ladd-pin-host {
      position: relative !important;
    }
    .blog-post-card__image-container.ladd-pin-host,
    .featured-blog-posts-card__image.ladd-pin-host {
      position: relative !important;
    }
    .ladd-pin-rte-wrapper {
      position: relative !important;
      display: inline-block !important;
      max-width: 100% !important;
      line-height: 0;
    }
    .ladd-pin-rte-wrapper img {
      display: block;
      max-width: 100%;
      height: auto;
    }
    .ladd-pin-btn {
      position: absolute;
      bottom: 12px;
      right: 12px;
      display: flex;
      align-items: center;
      gap: 6px;
      appearance: none;
      -webkit-appearance: none;
      font: inherit;
      -webkit-tap-highlight-color: transparent;
      background-color: #ffffff !important;
      border: 1px solid #e60023 !important;
      border-radius: 8px !important;
      padding: 6px 12px !important;
      text-decoration: none !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
      transition: transform 0.2s ease, box-shadow 0.2s ease !important;
      z-index: var(--layer-raised, 2) !important;
      cursor: pointer;
    }
    .ladd-pin-btn:hover {
      transform: scale(1.04);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.16) !important;
      background-color: #fff9f9 !important;
    }
    /* Make the whole button a single hit target, so a tap can never resolve to
       the icon or label instead of the anchor. */
    .ladd-pin-btn > * {
      pointer-events: none;
    }
    .ladd-pin-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ladd-pin-svg-path {
      fill: #e60023 !important;
    }
    .ladd-pin-text {
      color: #e60023 !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      font-family: inherit !important;
      line-height: 1.2 !important;
    }
    @media (max-width: 749px) {
      .ladd-pin-btn {
        bottom: 8px;
        right: 8px;
        padding: 4px 8px !important;
        font-size: 12px !important;
        border-radius: 6px !important;
      }
      .ladd-pin-btn svg {
        width: 16px;
        height: 16px;
      }
    }
  `;
  document.head.appendChild(style);

  // Helper to get Pinterest Button HTML
  function getButtonHtml() {
    return `
      <button type="button" class="ladd-pin-btn" on:click="ladd-pin-noop" aria-label="Save this image to Pinterest">
        <div class="ladd-pin-icon">
          <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="ladd-pin-svg-path" fill-rule="evenodd" clip-rule="evenodd" d="M12 2.33331C6.477 2.33331 2 6.81031 2 12.3333C2 17.8563 6.477 22.3333 12 22.3333C17.523 22.3333 22 17.8563 22 12.3333C22 6.81031 17.523 2.33331 12 2.33331ZM4 12.3333C4.00032 10.6683 4.52012 9.04495 5.48694 7.68944C6.45376 6.33392 7.81942 5.31384 9.39355 4.77138C10.9677 4.22892 12.6718 4.19111 14.2685 4.66323C15.8651 5.13535 17.2747 6.09387 18.3006 7.40517C19.3266 8.71647 19.9179 10.3152 19.9921 11.9785C20.0662 13.6419 19.6196 15.2869 18.7144 16.6843C17.8091 18.0817 16.4905 19.1618 14.9422 19.7742C13.3939 20.3865 11.6932 20.5005 10.077 20.1003L10.795 16.7263C11.482 17.3223 12.335 17.5493 13.154 17.5343C14.052 17.5173 14.954 17.2143 15.709 16.7393C16.461 16.2663 17.133 15.5793 17.501 14.7323C17.8988 13.8192 18.063 12.8215 17.9788 11.8291C17.8947 10.8367 17.5648 9.88085 17.019 9.04778C16.4731 8.21471 15.7285 7.53061 14.8523 7.0572C13.976 6.58379 12.9957 6.33595 11.9997 6.33604C11.0038 6.33613 10.0235 6.58415 9.14734 7.05772C8.27117 7.53129 7.52667 8.21552 6.98099 9.04869C6.43531 9.88186 6.10562 10.8378 6.02165 11.8302C5.93767 12.8226 6.10207 13.8203 6.5 14.7333C6.54979 14.8576 6.62404 14.9707 6.71835 15.0657C6.81266 15.1608 6.92509 15.236 7.049 15.2867C7.1729 15.3375 7.30574 15.3629 7.43964 15.3614C7.57354 15.3599 7.70577 15.3315 7.82848 15.2779C7.9512 15.2243 8.06191 15.1466 8.15403 15.0494C8.24616 14.9523 8.31783 14.8376 8.36479 14.7122C8.41175 14.5868 8.43304 14.4532 8.42741 14.3194C8.42178 14.1856 8.38933 14.0543 8.332 13.9333C8.09497 13.3884 7.98232 12.7975 8.00225 12.2036C8.02218 11.6097 8.17419 11.0277 8.44722 10.4999C8.72025 9.97211 9.10745 9.51177 9.58067 9.15236C10.0539 8.79294 10.6013 8.54348 11.183 8.4221C11.7647 8.30072 12.3661 8.31048 12.9436 8.45066C13.5211 8.59083 14.06 8.85791 14.5213 9.23248C14.9827 9.60705 15.3547 10.0797 15.6105 10.6161C15.8663 11.1525 15.9993 11.7391 16 12.3333C16 13.4283 15.59 14.4503 14.643 15.0463C14.155 15.3543 13.604 15.5263 13.117 15.5343C12.64 15.5443 12.275 15.4003 12.022 15.1353C11.774 14.8753 11.501 14.3733 11.501 13.4333C11.501 12.8333 11.73 12.3333 12.004 11.0413C12.0337 10.912 12.0373 10.7781 12.0147 10.6474C11.9921 10.5167 11.9437 10.3918 11.8723 10.2799C11.801 10.1681 11.7081 10.0716 11.5991 9.99598C11.4901 9.9204 11.3671 9.86726 11.2373 9.83966C11.1076 9.81207 10.9736 9.81056 10.8433 9.83524C10.7129 9.85992 10.5888 9.91028 10.4781 9.9834C10.3674 10.0565 10.2724 10.1509 10.1986 10.2611C10.1247 10.3713 10.0735 10.4951 10.048 10.6253L8.188 19.3683C6.92101 18.6816 5.86304 17.6654 5.12587 16.4271C4.3887 15.1889 3.99971 13.7744 4 12.3333Z" fill="black"></path>
          </svg>
        </div>
        <div class="ladd-pin-text">Save Pin</div>
      </button>
    `;
  }

  // 3. Button injection helpers
  function addContainerButton(container) {
    if (!container) return;
    if (container.querySelector('.ladd-pin-btn')) return;
    if (!container.querySelector('img')) return;

    container.classList.add('ladd-pin-host');
    container.insertAdjacentHTML('beforeend', getButtonHtml());
  }

  function addProductMediaButton(container) {
    if (!container) return;
    if (!container.closest(PRODUCT_GALLERY_SELECTOR)) return;
    if (container.closest(PRODUCT_EXCLUDED_SELECTOR)) return;
    if (!isProductTemplate()) return;

    addContainerButton(container);
  }

  function addRteImageButtons() {
    const contentContainers = document.querySelectorAll(
      '.blog-post-content, rte-formatter, .article-template__content'
    );
    contentContainers.forEach(function (content) {
      const images = content.querySelectorAll('img');
      images.forEach(function (img) {
        if (img.closest('.ladd-pin-rte-wrapper') || img.closest('.ladd-pin-host')) return;
        if (img.classList.contains('emoji')) return;
        if (img.width > 0 && img.width < 120 && img.height > 0 && img.height < 120) return;
        if (img.naturalWidth > 0 && img.naturalWidth < 120 && img.naturalHeight > 0 && img.naturalHeight < 120) return;

        const wrapper = document.createElement('span');
        wrapper.className = 'ladd-pin-rte-wrapper ladd-pin-host';
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
        wrapper.insertAdjacentHTML('beforeend', getButtonHtml());
      });
    });
  }

  function addAllButtons() {
    // 1. PDP media gallery
    document.querySelectorAll('.product-media').forEach(function (container) {
      addProductMediaButton(container);
    });

    // 2. Blog post featured image on article pages
    document.querySelectorAll('.blog-post-featured-image').forEach(function (container) {
      addContainerButton(container);
    });

    // 3. Blog post card images in blog listings and grids
    document.querySelectorAll('.blog-post-card__image-container').forEach(function (container) {
      addContainerButton(container);
    });

    // 4. Featured blog post cards
    document.querySelectorAll('.featured-blog-posts-card__image:not(.featured-blog-posts-card__image--placeholder)').forEach(function (container) {
      addContainerButton(container);
    });

    // 5. Article resource cards
    document.querySelectorAll(".resource-card[data-resource-type='article'] .resource-image:not(.resource-image--placeholder)").forEach(function (container) {
      addContainerButton(container);
    });

    // 6. RTE in-content images on blog post / article pages
    addRteImageButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addAllButtons);
  } else {
    addAllButtons();
  }

  let pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      addAllButtons();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // 4. Handle Click Event
  document.addEventListener(
    'click',
    function (e) {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const pinButton = target.closest('.ladd-pin-btn');
      if (!pinButton) return;

      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();

      const host =
        pinButton.closest(
          '.ladd-pin-host, .product-media, .ladd-pin-rte-wrapper, .blog-post-card__image-container, .blog-post-featured-image, .featured-blog-posts-card__image'
        ) || pinButton.parentElement;

      const img = host && host.querySelector('img');
      const imgSrc = img && (img.currentSrc || img.src);

      if (!imgSrc) return;

      // Find the target page URL and title:
      // If the button is on a blog card listing, resolve the direct link to the article
      const cardContext = host.closest(
        '.blog-post-card, .blog-post-item, .resource-list__item, .featured-blog-posts-card, .resource-card'
      );
      const link = cardContext
        ? cardContext.querySelector('a[href]')
        : host.querySelector('a[href]') || host.closest('a[href]');

      let pageUrl = window.location.href;
      if (link && link.href && !isProductTemplate() && !isArticleTemplate()) {
        pageUrl = link.href;
      }

      let pageTitle = document.title;
      if (cardContext) {
        const heading = cardContext.querySelector(
          'h1, h2, h3, h4, h5, h6, [class*="title"], [data-testid="blog-post-link"]'
        );
        if (heading && heading.textContent.trim()) {
          pageTitle = heading.textContent.trim();
        }
      } else if (img.alt && img.alt.trim()) {
        pageTitle = img.alt.trim();
      }

      const pinterestUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(pageUrl)}&media=${encodeURIComponent(imgSrc)}&description=${encodeURIComponent(pageTitle)}`;

      const popup = window.matchMedia('(hover: hover)').matches
        ? window.open(
            pinterestUrl,
            'pinterestShare',
            'width=600,height=600,toolbars=0,status=0,resizable=yes,scrollbars=yes'
          )
        : window.open(pinterestUrl, '_blank');

      if (!popup) window.location.href = pinterestUrl;
    },
    true
  );
})();
